import { useEffect } from "react";
import { toast } from "sonner";

// Aviso de versión nueva: una pestaña abierta no se actualiza sola. Cada pocos minutos (y al volver a la pestaña) se mira qué
// versión sirve el servidor; si es otra, se ofrece recargar (los cambios ya se guardan solos).
const actual = () => [...document.scripts].map((s) => s.src.match(/main\.[a-z0-9]+\.js/)?.[0]).find(Boolean);

export const NuevaVersion = () => {
  useEffect(() => {
    const mia = actual();
    if (!mia) return undefined;  // en desarrollo no hay versión empaquetada
    let avisado = false;
    const mirar = async () => {
      if (avisado || document.hidden) return;
      try {
        const html = await (await fetch("/", { cache: "no-store" })).text();
        const nueva = html.match(/main\.[a-z0-9]+\.js/)?.[0];
        if (nueva && nueva !== mia) {
          avisado = true;
          toast.info("Hay una versión nueva de EventPOL", {
            description: "Recargue para usarla. Lo que ha hecho ya está guardado.", duration: Infinity,
            action: { label: "Recargar", onClick: () => window.location.reload() },
          });
        }
      } catch { /* sin conexión: se vuelve a mirar más tarde */ }
    };
    const t = setInterval(mirar, 3 * 60 * 1000);
    document.addEventListener("visibilitychange", mirar);
    return () => { clearInterval(t); document.removeEventListener("visibilitychange", mirar); };
  }, []);
  return null;
};
